import { ChevronDownIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { useTranslation } from "react-i18next";
import MenuButton from "../../../ui/overlays/MenuButton";
import type { WorkspaceController } from "../workspaceController";
import { layoutString } from "./tabLabels";

/**
 * Below 1024 px one group shows, at full width (WA-10); this lists every open tab, so any of
 * them is one choice away, and closes one with its ×.
 */
export default function TabSwitcher({ controller }: { controller: WorkspaceController }) {
  const { t } = useTranslation();
  const tabs = controller.listTabs();
  const items = tabs.map((tab) => {
    const label = layoutString(tab.name, t);
    return {
      id: tab.id,
      label,
      className: tab.active ? "font-semibold" : undefined,
      action: { kind: "select" as const, onSelect: () => { controller.selectTab(tab.id); } },
      rowAction: {
        id: `close-${tab.id}`,
        label: t("shell.tabs.closeNamed", { name: label }),
        icon: <XMarkIcon className="h-4 w-4" aria-hidden="true" />,
        onSelect: () => { controller.close(tab.id); },
      },
    };
  });
  return (
    <MenuButton
      align="right"
      width="md"
      sections={[{ id: "tabs", items }]}
      renderTrigger={(trigger) => (
        <button {...trigger} type="button" className="app-topbar-nav-button app-topbar-view-button inline-flex items-center gap-1">
          {t("shell.tabs.count", { count: tabs.length })}
          <ChevronDownIcon className="h-4 w-4" aria-hidden="true" />
        </button>
      )}
    />
  );
}
